import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NotFound = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const handleBackHome = () => {
    if (user?.role === 'super_admin') {
      navigate('/admin/dashboard');
    } else if (user?.role === 'bde') {
      navigate('/bde/dashboard');
    } else {
      navigate('/');
    }
  };

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={<Button type="primary" onClick={handleBackHome}>Back Home</Button>}
    />
  );
};

export default NotFound;
